<template>
  <el-select
      :value="value"
      :multiple="multiple"
      :filterable="filterable"
      :remote="remote"
      :reserve-keyword="reserveKeyword"
      :placeholder="placeholder"
      @change="change"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @visible-change="visibleChange"
      :remote-method="remoteMethod"
      reserve-keyword
      :loading="loading"
      popper-class="selectLazy"
      :disabled="disabled">
    <el-option-group
        v-for="group in groups"
        :key="group.label"
        :label="group.label">
      <el-option
          v-for="item in group.options"
          :key="item[valueKey.key]"
          :label="item[valueKey.label]"
          :value="item[valueKey.value]">
      </el-option>
    </el-option-group>

    <li v-show="loadingOptions"
        style="color: #4A90E2;margin-top: 4px;height: 20px;display: flex;align-items: center;justify-content: center;">
      <span style="font-size: 12px;margin-right: 4px">拼命加载中</span><span class="el-icon-loading"></span>
    </li>
  </el-select>
</template>

<script>
export default {
  name: "lazySelect",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    valueKey: {
      type: Object,
      default: () => ({key: 'value', label: 'label', value: 'value'})
    },
    options: {
      type: Array,
      default: []
    },
    size: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function,
      default: null
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    loadingOptions: {
      type: Boolean,
      default: false
    },
    finishOptions: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let that = this
    return {
      init: true,
      checkValues: null,
      groups: [
        {
          label: '已勾选',
          options: []
        },
        {
          label: '列表',
          options: []
        }

      ]
    }
  },
  watch: {
    init:function(val){
      if(val){

      }
    },
    value: function (val) {

      if (val) {
        this.checkValues = val
      }
    },
    options: function (val, old) {
      this.groups[1].options = val

      if(val.length>0){
        this.initScroll()
      }
      if (this.value && this.init) {
        this.checkValues = this.value
      }
      this.init = false
    },
    checkValues: function (val, old) {

      if (typeof val === "object") {
        val = val || []
        old = old || []

        if (val.length > old.length) {
          let lastArr = val.filter(v => !old.includes(v))
          let res = this.options.filter((v) => lastArr.includes(v[this.valueKey.value]))
          this.groups[0].options = this.groups[0].options.concat(res)
        } else {
          let lastArr = old.filter(v => !val.includes(v))
          let index = [];
          this.groups[0].options.forEach((v, i) => {
            if (lastArr.includes(v[this.valueKey.value])) {
              index.push(i)
            }
          })
          index = index.sort((a, b) => (b - a))
          index.forEach((v) => {
            this.groups[0].options.splice(v, 1)
          })
        }
      } else {
        let res = this.options.filter((v) => v[this.valueKey.value] === val)
        this.groups[0].options = res
      }
    },


  },
  created() {
    this.init = true
  },
  mounted() {

  },
  methods: {
    change(v) {
      // this.checkValues = v
      this.$emit('change', v)
    },
    initScroll(){
      this.$nextTick(() => {
        let that = this;

        let docArr = document.querySelectorAll(".selectLazy")

        for (let i = 0; i < docArr.length; i++) {
          let scrollBox = docArr[i].querySelector(".el-scrollbar").querySelector(".el-select-dropdown__wrap")
          let scrollList = scrollBox.querySelector(".el-select-dropdown__list")
          let scrollHeight = parseInt(getComputedStyle(scrollList).height) - parseInt(getComputedStyle(scrollBox).height)

          let timer;
          scrollBox.addEventListener('scroll', (e) => {
            console.log(scrollHeight,e.target.scrollTop)
            if (!timer) {
              timer = setTimeout(() => {
                let offsetTop = e.target.scrollTop
                if (offsetTop >= scrollHeight - 1) {
                  if (!that.loadingOptions && !that.finishOptions) {
                    that.$emit('scrollEnd', offsetTop)
                  }
                }
                timer = null
              }, 100)
            }

          })
        }
      })
    },
    visibleChange(visible) {
      this.$emit('visibleChange')
      if (!visible) {
        return
      }
      this.initScroll()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/lazySelect.vue